/**
 * Lets apiClient notify the app when broker-session APIs return 401 so AuthProvider
 * can clear in-memory state without importing React from the HTTP layer.
 */

type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;
/** True after a successful GET /auth/me (or equivalent); avoids redirect loops for anonymous 401s. */
let hadAuthenticatedSession = false;

export function registerBrokerApiUnauthorizedHandler(fn: UnauthorizedHandler | null): void {
  handler = fn;
}

export function setHadAuthenticatedSession(value: boolean): void {
  hadAuthenticatedSession = value;
}

export function notifyBrokerApiUnauthorized(): void {
  if (!hadAuthenticatedSession) return;
  hadAuthenticatedSession = false;
  handler?.();
}
